import Vue from "vue";
import "./plugins/axios";
import "./filters/currency";
import "./filters/customFilters";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import vuetify from "./plugins/vuetify";
import "./assets/styles/app.scss";
import VueGeolocation from "vue-browser-geolocation";
import gaaVueLib from "gaa-vue-lib";
import "./registerServiceWorker";
import { createPinia, PiniaVuePlugin } from "pinia";
import GaaVueLib2 from "gaa-vue-lib-v2";
import "gaa-vue-lib-v2/style.css";

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV === "production" ? false : true;
Vue.config.silent = process.env.NODE_ENV === "production" ? false : true;
Vue.use(gaaVueLib, {
  store,
  excludeModules: ["auth"],
});

Vue.use(GaaVueLib2, { vuetify });

Vue.use(PiniaVuePlugin);
const pinia = createPinia();

new Vue({
  router,
  store,
  vuetify,
  pinia,
  render: (h) => h(App),
  mounted() {
    // Remove the loading indicator once Vue is mounted
    const loading = document.getElementById("app-loading");
    if (loading) {
      loading.remove();
    }
  },
}).$mount("#app");

Vue.use(VueGeolocation);
